import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PaymentService, AuthService } from 'epay-library';

@Component({
  selector: 'epay-common-employer-achd-home',
  templateUrl: './epay-common-employer-achd-home.component.html'
})
export class EpayCommonEmployerAchdHomeComponent implements OnInit {
  @Input() achdInfo = '';
  @Input() baseurl = '';
  paymentaccounts: any[] = [];
  isPaymentAccountSetup = false;
  homeButtonUrl = '';
  homeButtonText = '';
  isLoggedIn = false;

  constructor(
    private router: Router,
    private paymentservice: PaymentService,
    private datepipe: DatePipe,
    private authservice: AuthService
  ) {}

  ngOnInit() {
    this.authservice.isLoggedIn.subscribe(
      (isloggedIn) => (this.isLoggedIn = isloggedIn)
    );
    if (this.isLoggedIn) {
      this.homeButtonText = 'ACH Debit Home';
    } else {
      this.homeButtonText = 'Home';
    }
  }

  goToACHDebitLanding() {
    if (this.isLoggedIn) {
      this.paymentservice
        .getPaymentAccounts(this.baseurl)
        .subscribe((accounts) => {
          this.paymentaccounts = this.filterOldAccount(accounts);
          if (this.paymentaccounts.length === 0) {
            this.router.navigateByUrl('employer/achd/paymentaccounts');
          } else {
            this.router.navigateByUrl('employer/achd/landing');
          }
        });
    } else {
      this.router.navigateByUrl('home');
    }
  }

  filterOldAccount(accounts: any[]) {
    return accounts.filter(
      (account) =>
        this.datepipe.transform(account.inactiveDate, 'yyyy-MM-dd') ===
        '9999-12-31'
    );
  }
}

